<div class="main-slider-container">
  <div>
    <mat-slider
      class="main-slider"
      [disabled]="disabled()"
      [discrete]="true"
      [max]="max()"
      [min]="min()"
      [step]="step()"
      data-testid="slider-container"
    >
      <input
        (valueChange)="sliderChange($event)"
        [value]="sliderValue() || min()"
        data-testid="slider-thumb"
        matSliderThumb
      />
    </mat-slider>
    <div class="flex justify-between items-center mx-2">
      <span
        class="slider-restriction"
        data-testid="min-label"
      >{{ min() }} min</span>
      <span
        class="slider-restriction"
        data-testid="max-label"
      >{{ max() }} max</span>
    </div>
  </div>
  <mat-form-field
    class="main-slider-input"
    appearance="fill"
  >
    <input
      type="number"
      class="slider-input-field"
      (blur)="inputBlur()"
      (ngModelChange)="sliderChange($event)"
      [disabled]="disabled()"
      [max]="max()"
      [min]="min()"
      [ngModel]="sliderValue()"
      autocomplete="off"
      data-testid="slider-number-input"
      matInput
      name="value"
      placeholder="5"
    />
  </mat-form-field>
</div>
